'use client';

import type { PropsWithChildren } from 'react';

import AuthProvider from '@shared/common/providers/AuthProvider';
import { CompositeProvider } from '@shared/common/providers/CompositeProvider';
import GlobalModalsProvider from '@shared/common/providers/GlobalModalsProvider';
import { GlobalStateProvider } from '@shared/common/providers/GlobalStateProvider';
import GoogleTagManagerProvider from '@shared/common/providers/GoogleTagManagerProvider';
// eslint-disable-next-line deprecate/import
import LegacyWeb3Provider from '@shared/common/providers/LegacyWeb3Provider';
import { MixPanelProvider } from '@shared/common/providers/MixPanelProvider';
import { NewsletterSubscriptionProvider } from '@shared/common/providers/NewsletterSubscriptionProvider';
import PasskeyProvider from '@shared/common/providers/PasskeyProvider';
import { SocketProvider } from '@shared/common/providers/socket';
import ToastProvider from '@shared/common/providers/ToastProvider';
import TonProvider from '@shared/common/providers/TonProvider';
import TurnstileProvider from '@shared/common/providers/TurnstileProvider';
import UserAgentDetectProvider from '@shared/common/providers/UserAgentDetectProvider';

import GlobalModalsMagicsquare from '@msq/components/providers/GlobalModalsMagicsquare/GlobalModalsMagicsquare';
import { OverlaysProvider } from '@ui/uikit/components/common/Overlays';
import { LightweightQueryProviderSsr } from '@utilities/react-query';

export const UniversalProvider = ({ children }: PropsWithChildren) => {
  return (
    <CompositeProvider
      providers={[
        TurnstileProvider,
        LegacyWeb3Provider,
        GlobalStateProvider,
        GlobalModalsProvider,
        LightweightQueryProviderSsr,
        AuthProvider,
        {
          provider: PasskeyProvider,
          properties: {
            appId: process.env.NEXT_PUBLIC_PASSKEY_APP_ID || '',
          },
        },
        SocketProvider,
        TonProvider,
        ToastProvider,
        MixPanelProvider,
        GoogleTagManagerProvider,
        UserAgentDetectProvider,
        GlobalModalsMagicsquare,
        NewsletterSubscriptionProvider,
        {
          provider: OverlaysProvider,
          properties: {
            layers: ['ai-agent', 'menus', 'modals'],
          },
        },
      ]}
    >
      {children}
    </CompositeProvider>
  );
};
